import { useEffect, useMemo, useState } from 'react';

// Third-party

import momentTz from 'moment-timezone';

// Hooks
import { useAppSelector } from '../../../hooks/useAppStore';
import { useCustomForm } from '../../../hooks/useForm';

// Redux-toolkit
import { getSelectedShift } from '../../../store/sheets/selectors';

// Data
import { INITIAL_STATE } from '../data/sheets';

// Types
import { TEditShift } from '../../../types';

export function useEditShift() {
  const selectedShift = useAppSelector(getSelectedShift);

  const {
    formInputs,
    setFormInputs,
    setPrevFormInputs,
    isEdited,
    handleFormChange,
  } = useCustomForm(INITIAL_STATE);

  const [mode, setMode] = useState('create');

  useEffect(() => {
    if (selectedShift?.id) {
      setMode('edit');

      const shiftData = {
        startDate: momentTz(selectedShift.start),
        endDate: selectedShift?.end ? momentTz(selectedShift.end) : momentTz(selectedShift.start),
        startTime: selectedShift?.start ? momentTz.tz(selectedShift.start, selectedShift.timezone) : momentTz(),
        endTime: momentTz.tz(selectedShift.end, selectedShift.timezone),
        location: selectedShift.location,
        breaks: selectedShift.breaks?.map((breakData) => ({
          ...breakData,
          breakStart: momentTz.tz(breakData.breakStart, selectedShift.timezone),
          breakEnd: momentTz.tz(breakData.breakEnd, selectedShift.timezone),
        })),
      } as unknown as TEditShift;

      setFormInputs(shiftData);
      setPrevFormInputs(shiftData);
    } else {
      setMode('create');
      setFormInputs(INITIAL_STATE);
    }
  }, [selectedShift]);

  const getFormInputs = useMemo(() => formInputs, [formInputs]);

  const resetForm = () => {
    setFormInputs(INITIAL_STATE);
  };

  return {
    formInputs,
    setFormInputs,
    getFormInputs,
    isEdited,
    mode,
    handleFormChange,
    resetForm,
  };
}
